import styled from 'styled-components';

import { gridSizes } from 'utils/style';

import PaginationButton from 'components/orders/PaginationButton/container';

export default styled(PaginationButton)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    min-width: 150px;
    font-size: ${gridSizes('M')};
    margin-top: ${gridSizes('XL')};
    margin-bottom: ${gridSizes('XL')};
  }
`;
